module.exports = __webpack_public_path__ + "img/contabilidad-finanzas.53934b6f.jpg";